import React from 'react';
import { Typography } from 'material-ui';
import { assets } from '../../../assets';
import { CircularProgress } from '@material-ui/core';

export class AvoidedCO2ConvertedHome extends React.Component {
  render() {
    const {
      classes,
      t,
      energyInWh,
      loading,
      average_household_electricity_consumption_in_kwh,
    } = this.props;

    if (loading) {
      return <CircularProgress size={10} className={classes.buttonProgress} />;
    }

    /*
    Equivalence en consommation de x foyers français

    Consommation annuelle moyenne par foyer en France en 2017
    Pour connaître la consommation électrique moyenne d'un foyer résidentiel français, il suffit de diviser la quantité totale d'électricité résidentielle consommée (en TWh) par le nombre de foyers résidentiels.

    158,6 TWh / 32 078 000 sites = 4 944 kWh consommation électrique annuelle par foyer français.
    */

    let totalEnergyMatchedInkWh = energyInWh / 1000;

    let convertedEnergyMatchedInNumberOfFrenchHomes = Math.round(
      totalEnergyMatchedInkWh / average_household_electricity_consumption_in_kwh
    );

    return (
      <div>
        <div style={{ marginBottom: 20 }}>
          <img
            src={assets.icons.houseIcon}
            style={{
              display: 'block',
              marginLeft: 'auto',
              marginRight: 'auto',
              width: 40,
              height: 40,
            }}
            alt=""
          />
        </div>
        <Typography
          className={classes.title}
          variant="subheading"
          gutterBottom
          align="center"
          color="textSecondary"
          style={{ fontSize: '0.875rem' }}
        >
          <span style={{ fontSize: '1.2rem', color: '#F87733' }}>
            {convertedEnergyMatchedInNumberOfFrenchHomes}
          </span>
        </Typography>
        <Typography
          className={classes.title}
          variant="subheading"
          gutterBottom
          align="center"
          color="textSecondary"
          style={{ fontSize: '0.875rem' }}
        >
          {t('homes')}
        </Typography>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/EquivalentToCards/ConvertedAvoidedCO2/AvoidedCO2ConvertedHome.js